import { makeVar } from '@apollo/client'

const timeDiff = makeVar(0)
const isUserActive = makeVar(true)

export { timeDiff, isUserActive }
